var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"material-icons-round md-24",attrs:{"title":_vm.$t('buttons.fullscreen')},on:{"click":function($event){return _vm.toggleFullscreen($event)}}},[_vm._v(" "+_vm._s(_vm.enabled ? "fullscreen_exit" : "fullscreen")+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }